import { render, staticRenderFns } from "./FromMails.list.vue?vue&type=template&id=3c251821&"
import script from "./FromMails.list.vue?vue&type=script&lang=js&"
export * from "./FromMails.list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports